import React, { useState } from 'react';
import { useGetMyBetsQuery } from 'store/gamesApi';
import Pagination from '../pagination/pagination';
import CasinoHistoryTable from './casinoHistoryTable';
import styles from './casinoHistory.module.scss';

const CasinoHistory: React.FC = () => {
  const [page, setPage] = useState(1);
  const limit = 10;

  const {
    data: response,
    isLoading,
    isFetching,
  } = useGetMyBetsQuery({ page, limit }, { refetchOnMountOrArgChange: true });

  const items = response?.data?.items || [];
  const totalPages = Math.ceil((response?.data?.total || 0) / limit) || 1;

  const loading = isLoading || isFetching;

  return (
    <div className={styles.container}>
      <CasinoHistoryTable data={items} loading={loading} limit={limit} />

      {!loading && items.length > 0 && totalPages > 1 && (
        <div className={styles.paginationWrapper}>
          <Pagination currentPage={page} totalPages={totalPages} onPageChange={setPage} />
        </div>
      )}
    </div>
  );
};

export default CasinoHistory;
